/**
 * Redirige vers la page d'erreur 401 si l'utilisateur n'est pas authentifié
 */

import { useAuthStore } from "@/store/auth";

export default defineNuxtRouteMiddleware((to) => {
  const { $pinia } = useNuxtApp();
  const authStore = useAuthStore($pinia);
  if (!authStore.isLogged) {
    return abortNavigation({ fatal: true, statusCode: 401, data: { to }, statusMessage: "Vous devez vous connecter pour accéder à cette page." });
  }
  return;
})
